import React, { useEffect } from 'react';
import logo from './logo.svg';
import './App.css';
import { BrowserRouter, Routes, Route, Navigate, } from "react-router-dom";
import 'rsuite/dist/rsuite.min.css';

//i18n 
import './i18n';  // Import i18n configuration


import { useCookies } from 'react-cookie';
import DashboardLayout from './layout/authlayout';
import Dashboard from './componenets/dashboard';
import { useLocation } from 'react-router-dom';


import AuthPage from './componenets/Auth/AuthPage';
// Blog
import IndexBlog from './componenets/Blog/indexBlog';
import ListBlog from './componenets/Blog/ListBlog';
import ListArticles from './componenets/Blog/ListArticles';
import EditBlog from './componenets/Blog/editBlog';

// Setting
import IndexSetting from './componenets/Setting/indexSetting';
import SettingPage from './componenets/Setting/general';
import SocialPage from './componenets/Setting/social';
import ContactPage from './componenets/Setting/contact';
import AffiliateSettingsPage from './componenets/Setting/AffiliateSettings';
import ShippingSettingsPage from './componenets/Setting/ShippingSettings';

//Gallery
import IndexGallery from './componenets/Gallery/indexGallery';
import GalleryList from './componenets/Gallery/listGallery';
import EditGallery from './componenets/Gallery/editGallery';
import EditDetail from './componenets/Gallery/DetailImage';
import ListSlider from './componenets/Gallery/listSlider';
import EditSlider from './componenets/Gallery/editSlider';

// User
import IndexUser from './componenets/User/indexUser';
import UserList from './componenets/User/UserList';
import EdtiUser from './componenets/User/EdtiUser';
// Menus 
import MenuGroup from './componenets/Menus/MenuGroup';
import MenuDetail from './componenets/Menus/MenuDetail';
// Logout
import { LogOut } from './logout/LogOut';
// Preline disabled - causing DOM initialization conflicts with rsuite
// import "preline/preline";
// import { IStaticMethods } from "preline/preline";
import EditPost from './componenets/Blog/editPost';
import FeatureIndex from './componenets/Feature/featureIndex';

// Request Forms
import RequestFroms from './componenets/Feature/requestForms';

// Iran Map
import IranMap from './componenets/Map/ListMap';

// Redirect Address
import RedirectAddress from './componenets/RedirectAddress/RedirectAddress';



// Shop
import IndexProducts from './componenets/Prodcuts/indexProducts';
import ListProductsGroup from './componenets/Prodcuts/listProductsGroup';
import EditProductsGroup from './componenets/Prodcuts/EditProductsGroup';
import ListPr from './componenets/Prodcuts/LisstProducts';
import EditProducts from './componenets/Prodcuts/EditProducts';
import ListBrands from './componenets/Prodcuts/ListBrands';
import EditBrand from './componenets/Prodcuts/EditBrand';
import GiftProductsList from './componenets/Prodcuts/GiftProductsList';
import EditGiftProduct from './componenets/Prodcuts/EditGiftProduct';
import AboutUs from './componenets/About/About';
import ListPricesGroup from './componenets/Prodcuts/PriceGroup';
import ProductGroupEdit from './componenets/Prodcuts/PriceGroupEdit'
import PostShop from './componenets/Shop/postShop';
import IndexShop from './componenets/Shop/indexShop';
import ListComments from './componenets/Comments/ListComments';
import ListTickets from './componenets/Tickets/ListTickets';
import UserTickets from './componenets/Tickets/UserTickets';
import TicketDetail from './componenets/Tickets/TicketDetail';

// Affiliate
import AffiliateRequests from './componenets/Affiliate/AffiliateRequests';
import AffiliateOrders from './componenets/Affiliate/AffiliateOrders';

// Campaign
import CampaignRequests from './componenets/Campaign/CampaignRequests';
import CampaignTimeSlots from './componenets/Campaign/CampaignTimeSlots';
import CampaignProductsList from './componenets/Campaign/CampaignProductsList';
import EditCampaignProduct from './componenets/Campaign/EditCampaignProduct';


// Story
import StoryDetail from './componenets/Story/Story';
import EditStory from './componenets/Story/EditStory';

// Testimonial
import IndexTestimonial from './componenets/Testimonial/indexTestimonial';
import ListTestimonialGroup from './componenets/Testimonial/ListTestimonialGroup';
import EditTestimonialGroup from './componenets/Testimonial/EditTestimonialGroup';
import ListTestimonialDetail from './componenets/Testimonial/ListTestimonialDetail';
import EditTestimonialDetail from './componenets/Testimonial/EditTestimonialDetail';

// invoice 
import InvoiceList from './componenets/Invoice/InvoiceList';
import InvoiceDetial from './componenets/Invoice/InvoiceDetail';
import InvoiceLabel from './componenets/Invoice/InvoiceLabel';
/*
declare global {
  interface Window {
    HSStaticMethods: IStaticMethods;
  }
}
*/

function App() {
  const [cookies] = useCookies(['token']);
  const token = cookies.token; // Retrieve the token
  //const location = useLocation();

  // Preline autoInit disabled - was causing DOM conflicts
  // useEffect(() => {
  //   try {
  //     if (window.HSStaticMethods?.autoInit) {
  //       window.HSStaticMethods.autoInit();
  //     }
  //   } catch (error) {
  //     console.warn('Preline autoInit warning:', error);
  //   }
  // }, []);
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/logout" element={<LogOut />} />

        <Route path="/">
          <Route index element={!token ? <AuthPage /> : <Navigate to="/dashboard" />} />
        </Route>
        <Route
          path="/dashboard"
          element={token ? <DashboardLayout /> : <Navigate to="/" />}>
          <Route index element={<Dashboard />} />
          <Route path='about' element={<AboutUs />} />
          <Route path="Blog"  >
            <Route index element={<IndexBlog />} />
            <Route path="list" element={<ListBlog />} />
            <Route path="GroupEdit/:Id" element={<EditBlog />} />
            <Route path="Articles" element={<ListArticles />} />
            <Route path="EditPost/:Id" element={<EditPost />} />
          </Route>
          <Route path="Setting"  >
            <Route index element={<IndexSetting />} />
            <Route path="general" element={<SettingPage />} />
            <Route path="socialnetwork" element={<SocialPage />} />
            <Route path="contact" element={<ContactPage />} />
            <Route path="affiliate" element={<AffiliateSettingsPage />} />
            <Route path="shipping" element={<ShippingSettingsPage />} />
          </Route>
          <Route path="Gallery"  >
            <Route index element={<IndexGallery />} />
            <Route path="gallery" element={<GalleryList />} />
            <Route path="gallery/:Id" element={<EditGallery />} />
            <Route path="detailimage/:Id" element={<EditDetail />} />
            <Route path="list" element={<ListSlider />} />
            <Route path="list/:Id" element={<EditSlider />} />
          </Route>
          <Route path="User"  >
            <Route index element={<IndexUser />} />
            <Route path="invoices" element={<InvoiceList />} />
            <Route path="invoices/:Id" element={<InvoiceDetial />} />
            <Route path="invoices/label/:Id" element={<InvoiceLabel />} />
            <Route path="list" element={<UserList />} />
            <Route path="list/:Id" element={<EdtiUser />} />
          </Route>
          <Route path="Feature"  >
            <Route index element={<FeatureIndex />} />
            <Route path="Menus" element={<MenuGroup />} />
            <Route path="Menus/:Id" element={<MenuDetail />} />
            <Route path="RequestForms" element={<RequestFroms ></RequestFroms>}></Route>
            <Route path="IranMap" element={<IranMap ></IranMap>}></Route>
            <Route path="RedirectAddress" element={<RedirectAddress ></RedirectAddress>}></Route>
            <Route path="Story" element={<StoryDetail />} />
            <Route path="Story/:Id" element={<EditStory />} />

          </Route>
          <Route path="Products"  >
            <Route index element={<IndexProducts />} />
            <Route path="ProductsGroup" element={<ListProductsGroup />} />
            <Route path="ProductsGroup/:Id" element={<EditProductsGroup />} />
            <Route path="Products" element={<ListPr />} />
            <Route path="Products/:Id" element={<EditProducts />} />
            <Route path="Brands" element={<ListBrands />} />
            <Route path="Brands/:Id" element={<EditBrand />} />
            <Route path="GiftProducts" element={<GiftProductsList />} />
            <Route path="GiftProducts/:Id" element={<EditGiftProduct />} />
            <Route path="PriceGroup" element={<ListPricesGroup />} />
          </Route>
          <Route path="PriceGroup"  >
            <Route index element={<ListPricesGroup />} />
            <Route path=":Id" element={<ProductGroupEdit />} />

          </Route>
          <Route path="shop"  >
            <Route index element={<IndexShop />} />
            <Route path="post" element={<PostShop />} />

          </Route>
          <Route path="Comments"  >
            <Route index element={<ListComments />} />
          </Route>
          <Route path="Tickets"  >
            <Route index element={<ListTickets />} />
            <Route path=":id" element={<TicketDetail />} />
          </Route>
          <Route path="UserTickets"  >
            <Route index element={<UserTickets />} />
          </Route>
          <Route path="Affiliate"  >
            <Route index element={<AffiliateRequests />} />
            <Route path="Requests" element={<AffiliateRequests />} />
            <Route path="Orders" element={<AffiliateOrders />} />
          </Route>
          <Route path="Testimonial"  >
            <Route index element={<IndexTestimonial />} />
            <Route path="GroupList" element={<ListTestimonialGroup />} />
            <Route path="GroupEdit/:Id" element={<EditTestimonialGroup />} />
            <Route path="Details/:Id" element={<ListTestimonialDetail />} />
            <Route path="DetailEdit/:Id" element={<EditTestimonialDetail />} />
          </Route>
          <Route path="Campaign">
            <Route index element={<CampaignRequests />} />
            <Route path="Requests" element={<CampaignRequests />} />
            <Route path="TimeSlots" element={<CampaignTimeSlots />} />
            <Route path="Products" element={<CampaignProductsList />} />
            <Route path="Products/:Id" element={<EditCampaignProduct />} />
          </Route>


        </Route>

      </Routes>


    </BrowserRouter>

  );
}

export default App;
